"use strict";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";

const listSensorsService = {
  getListSensors: function (options) {
    return api.get("/Sensors", WithToken.headersToken({ params: options }, configuration.cookieName));
  },
};

export default listSensorsService;
